import React from "react";
import { AlertTriangle, AlertCircle } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const LABELS = {
  URGENT: { de: "Dringend", en: "Urgent", tr: "Acil", ar: "عاجل", ro: "Urgent", fa: "فوری", ps: "بیړنی", uk: "Терміново", pl: "Pilne", bg: "Спешно", it: "Urgente", es: "Urgente", fr: "Urgent" },
  IMPORTANT: { de: "Wichtig", en: "Important", tr: "Önemli", ar: "مهم", ro: "Important", fa: "مهم", ps: "مهم", uk: "Важливо", pl: "Ważne", bg: "Важно", it: "Importante", es: "Importante", fr: "Important" },
};

const STYLE = {
  URGENT: "bg-[#FDECEC] text-[#C0392B] border-[#F5C6C6]",
  IMPORTANT: "bg-[#FFF3E9] text-[#B36B00] border-[#FBD9BC]",
};

// Grounded AI priority indicator. Renders nothing for NORMAL (keeps the UI calm).
export function PriorityBadge({ priority }) {
  const { lang } = useI18n();
  if (priority !== "URGENT" && priority !== "IMPORTANT") return null;
  const Icon = priority === "URGENT" ? AlertTriangle : AlertCircle;
  const label = (LABELS[priority] || {})[lang] || LABELS[priority].en;
  return (
    <span
      data-testid={`priority-badge-${priority.toLowerCase()}`}
      className={`inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${STYLE[priority]}`}
    >
      <Icon size={11} /> {label}
    </span>
  );
}
